module.exports = __webpack_public_path__ + "img/home-page.1f720b1d.png";